import {
  installAdobeLaunch,
  trackApplicationStartupEvent
} from 'apps/acquisition/packages/adobe-launch';
import {
  getAcquisitionMode,
  useAcquisitionContext,
  useAdobeLaunchUrl,
  useContextRequest,
  useQueryParam
} from 'apps/acquisition/packages/environment';
import { trackApplicationStartup } from 'apps/acquisition/packages/google-tag-manager';
import { useBaseUrl } from 'packages/react-nano-router';
import { useEffect } from 'react';

export const useInitializeTracking = (variant: string) => {
  const { name, originating_distributor, type } = useAcquisitionContext();
  const { aid, site_id, sub } = useContextRequest();
  const medium = useQueryParam('medium');
  const mode = getAcquisitionMode();
  const adobeLaunchUrl = useAdobeLaunchUrl();
  const baseUrl = useBaseUrl();

  // Track app startup in GTM
  useEffect(() => {
    trackApplicationStartup({
      contextName: name,
      mode,
      medium,
      aid,
      brand: variant,
      siteId: site_id,
      sub
    });
  }, [name, aid, site_id, sub, medium, mode, variant]);

  // Install Adobe Launch
  useEffect(() => {
    if (adobeLaunchUrl) {
      installAdobeLaunch(adobeLaunchUrl);
    }
  }, [adobeLaunchUrl]);

  // Track app startup in Adobe
  useEffect(() => {
    if (adobeLaunchUrl) {
      const page =
        location.pathname.replace(baseUrl, '').replace('/', '') || 'order-card';
      trackApplicationStartupEvent({
        aid,
        contextName: name,
        contextType: type,
        page,
        distributor: originating_distributor,
        env: mode,
        medium,
        siteId: site_id,
        variant
      });
    }
  }, [
    adobeLaunchUrl,
    aid,
    baseUrl,
    medium,
    mode,
    name,
    originating_distributor,
    site_id,
    type,
    variant
  ]);
};
